import React, {useState} from "react";
import {useHistory} from "react-router";
import style from "../menu.scss";
import componentStyle from '@/styles/Component.scss';
import globalStyle from '@/styles/Global.scss'
import {PasswordRegister} from "@/entity/User";
import MButton from "@/components/atom/MButton";
import Layout from "@/layout/Layout";
import {changePassword} from "@/api";

const ChangePassword = () => {
  const history = useHistory()
  const [password, setPassword] = useState(new PasswordRegister({}))

  const updatePassword = (diff) => {
    setPassword(new PasswordRegister({...password, ...diff}))
  }

  const save = async () => {
    await changePassword({ password: password.password })
    history.push(`/setting`)
  }

  const goBack = () => {
    history.push(`/setting`)
  }

  return (
    <Layout title={'パスワードの変更'}>
      <div className={componentStyle.inputArea}>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>
            パスワード{password.invalidPassword() && <span className={style.unMatch}>パスワードは8文字以上で入力してください</span>}
          </div>
          <div className={globalStyle.value}>
            <input type={"password"} className={style.input} value={password.password}
                   onInput={(e) => updatePassword({password: e.target.value})}/>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>
            パスワード(再入力){password.unMatchPassword() && <span className={style.unMatch}>同じパスワードを入力してください</span>}
          </div>
          <div className={globalStyle.value}>
            <input type={"password"} className={style.input} value={password.password2}
                   onInput={(e) => updatePassword({password2: e.target.value})}/>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <MButton image={'passwordKoushin.png'} disabled={!password.canRegister()} onClick={save} value={'変更'}/>
          <MButton image={'back.png'} onClick={goBack} value={'戻る'}/>
        </div>
      </div>
    </Layout>
  )
}

export default ChangePassword;
